@if (!triggerHidden()) {
  <!-- Trigger: dot or icon button. Serves as the CDK overlay origin. -->
  <button type="button"
          matIconButton
          class="mat-icon-button-small"
          cdkOverlayOrigin
          #origin="cdkOverlayOrigin"
          [attr.aria-label]="ariaLabel()"
          (click)="toggle()">
    @if (triggerIcon()) {
      <mat-icon>{{ triggerIcon() }}</mat-icon>
    } @else {
      <span class="swatch-dot m-auto"
            [style.background]="color()"
            [style.width.px]="size()"
            [style.height.px]="size()"></span>
    }
  </button>

  <!-- Floating panel: rendered in a CDK portal, never affects layout flow -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (backdropClick)="close()"
    (detach)="close()">
    <ng-container [ngTemplateOutlet]="pickerPanel" />
  </ng-template>
}

@if (triggerHidden()) {
  <!-- No trigger: panel rendered inline (caller already controls overlay placement) -->
  <ng-container [ngTemplateOutlet]="pickerPanel" />
}

<ng-template #pickerPanel>
  <div class="color-picker-panel">
    <span [cpToggle]="true"
          cpDialogDisplay="inline"
          [colorPicker]="pendingColor()"
          (colorPickerChange)="pendingColor.set($event); colorChange.emit($event)"
          [cpAlphaChannel]="alphaChannel()"
          [cpOutputFormat]="outputFormat()"
          [cpPresetColors]="presetColors()"
          (colorPickerOpen)="fixHexInput()"
          [cpOKButton]="true"
          cpOKButtonText="Save"
          cpOKButtonClass="mdc-button mat-mdc-raised-button save-button"
          [cpCancelButton]="true"
          cpCancelButtonText="Restore Default"
          cpCancelButtonClass="mdc-button mat-mdc-raised-button restore-button"
          (colorPickerSelect)="handleApply($event)"
          (colorPickerCancel)="handleCancel()"
          [cpSaveClickOutside]="false">
    </span>
  </div>
</ng-template>
